module.exports = __webpack_public_path__ + "static/media/Medalha-Mérito.40a84502.svg";